// extracted by mini-css-extract-plugin
export default {"TablaInflacionMesAMes":"TablaInflacionMesAMes_TablaInflacionMesAMes__URizh"};